import {get} from '../utils'
import {includeQuery} from './utils';
import {getActiveChannel} from "../authentication/utils";
import {getDateInt} from "../../../utils"

export default host => (clientId, playlistId, tags = [], notTags = [], query = '', include = includeQuery) => 
  get(`${host}/clients/${clientId}${getActiveChannel() ? `/channels/${getActiveChannel()}` : ``}/musics?playlist_id=${playlistId}&tags_ids=${tags.join(',')}&not_tags_ids=${notTags.join(',')}${query}&${include};favorite&per_page=100&seed=${getDateInt()}`)
    .then(response => response.json())
    .then(json => json.data)